import React, { useEffect, useState } from 'react';
import { PrimaryButton } from '../components/button';
import { Constants } from '../lib/const/constants';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { encryptPayload } from '../utils/encryption';

export default function VerifyPhone() {
    const navigate = useNavigate();
    const [change, setChange] = useState(false);
    const [countrycode, setCountrycode] = useState("44");
    const [phone, setPhone] = useState("");
    const [otp, setOtp] = useState(Array(6).fill(""));
    const [count, setCount] = useState(60);
    const [loading, setLoading] = useState(false);
    const inputsRef = React.useRef([]);

    const getData = async () => {
        setCountrycode(sessionStorage.getItem('user_country_code'))
        var phoneNo = sessionStorage.getItem('user_phone');
        // phoneNo = phoneNo?.replace(/^0+(?=\d)/, '');
        setPhone(phoneNo)
    }

    useEffect(() => {
        getData()
        const interval = setInterval(() => {
            if (count === 0) {
                clearInterval(interval);
            } else {
                setCount(count - 1);
            }
        }, 1000);
        return () => clearInterval(interval);
    }, [count])

    const setAsyncData = async (key, value) => {
        sessionStorage.setItem(key, value)
    }

    const updateMobile = async () => {
        const token = sessionStorage.getItem('registrationToken');
        const encryptedPayload = await encryptPayload({
            "phone": phone,
            "platform": 'web',
            "extraParamValidation": 'trustedfromweb'
        })
        await axios.post(Constants.BASE_URL + 'API-FX-108-ModifyMobile', encryptedPayload, {
            headers: {
                Authorization: "Bearer " + token,
                fx_key: Constants.SUBSCRIPTION_KEY
            }
        }).then(resp => {
            setAsyncData('user_phone', phone)
            toast.success(resp.data.message)
        }).catch(err => {
            toast.error(err.response?.data?.message || 'Update failed');
        });
        setChange(false);
    }

    const resendOtp = async () => {
         setOtp(Array(6).fill(""));
        setLoading(true);
        const url = Constants.BASE_URL + 'API-FX-107-ResendMobileOTP';
        const token = sessionStorage.getItem('registrationToken');
        await axios.post(url, {}, {
            headers: {
                Authorization: "Bearer " + token,
                fx_key: Constants.SUBSCRIPTION_KEY
            }
        }).then(resp => {
            setCount(60);
            toast.success(resp.data.message);
        }).catch(() => {
            toast.error('Please try after sometime.');
        }).finally(() => setLoading(false));
    }
    //console.log(otp);
    const otpValidate = async () => {
        setLoading(true);
        const token = sessionStorage.getItem('registrationToken');
        const deviceId = sessionStorage.getItem('deviceid');
        const userid = sessionStorage.getItem('userid');
        const encryptedPayload = await encryptPayload({
            "code": otp.join(""),
            "platform": 'web',
            "extraParamValidation": 'trustedfromweb'
        });
        await axios.post(Constants.BASE_URL + 'API-FX-106-MobileVerification', encryptedPayload, {
            headers: {
                Authorization: "Bearer " + token,
                fx_key: Constants.SUBSCRIPTION_KEY
            }
        }).then(async(resp) => {
              //console.log(resp);
            if (resp.data.message.includes('Verified')) {
                const dropencryptedPayload = await encryptPayload({
                    screen_name: "MOBILE_OTP_3",
                    meta: { enteredOtp: otp.join("") },
                    device_id: deviceId,
                    user_id: userid
                });
                axios.post(Constants.BASE_URL + "API-FX-159-DROPSCREEN", dropencryptedPayload, {
                    headers: {
                        fx_key: Constants.SUBSCRIPTION_KEY
                    }
                }).then(() => navigate('/VerifyEmail'))
                  .catch(dropError => toast.error(dropError.response?.data?.message));
            } else {
                toast.error('Invalid OTP');
            }
        }).catch(() => toast.error('Invalid OTP'))
          .finally(() => setLoading(false));
    };



const setOtpAt = (idx, val) => {
  setOtp(prev => {
    const next = [...prev];
    next[idx] = val;
    return next;                
  });
};

const handleOtpChange = (idx) => (e) => {
  const v = e.target.value.replace(/\D/g, "");   
  if (!v) {
    setOtpAt(idx, "");
    return;
  }
  setOtpAt(idx, v[v.length - 1]);                
  if (idx < 5) inputsRef.current[idx + 1]?.focus();
};

const handleKeyDown = (idx) => (e) => {
  if (e.key === "Backspace") {
    e.preventDefault();
    if (otp[idx]) {
      setOtpAt(idx, "");
    } else if (idx > 0) {
      setOtpAt(idx - 1, "");
      inputsRef.current[idx - 1]?.focus();
    }
  } else if (e.key === "ArrowLeft") {
    inputsRef.current[idx - 1]?.focus();
  } else if (e.key === "ArrowRight") {
    inputsRef.current[idx + 1]?.focus();
  }
};

const handlePaste = (idx) => (e) => {
  const pasted = e.clipboardData.getData("text").replace(/\D/g, "");
  if (!pasted) return;
  e.preventDefault();
  const next = [...otp];
  for (let i = 0; i < pasted.length && idx + i < 6; i++) {
    next[idx + i] = pasted[i];
  }
  setOtp(next);                                  
  const last = Math.min(5, idx + pasted.length - 1);
  inputsRef.current[last]?.focus();
};



    return (
         <div className="min-h-screen w-full bg-white flex flex-col">
  <div className="w-full border-b border-[#0B214E33] py-6 px-6">
    <img src="/fx_logo_old.png" alt="FXMaster Logo" className="w-[160px]" />
  </div>
            <ToastContainer />
            <div className='flex flex-1 items-center justify-center px-4'>
            <div className="w-full max-w-lg bg-[#DEE9FC] rounded-2xl px-8 py-10 text-center" style={{ boxShadow: '0px 13px 35px rgba(0, 0, 0, 0.08)' }}>
                <h2 className="text-[#0B214E] text-xl font-bold mb-2">Mobile Verification</h2>
                <p className="text-sm text-[#0B214E] mb-6">
                    Please enter the six digit verification code was sent to<br />
                    <span className="font-semibold">+{countrycode} {phone}</span>{' '}
                    {!change && <span onClick={() => setChange(true)} className="text-blue-600 cursor-pointer underline ml-1">Change</span>}
                </p>

                {change && (
                    <div className="flex mb-4">
                        <input
                            type="number"
                            placeholder="Enter Your Mobile Number"
                            className="flex-grow p-2 rounded-l-2xl bg-white border border-gray-300"
                            onChange={(e) => setPhone(e.target.value)}
                        />
                        <button
                            onClick={updateMobile}
                            className="bg-blue-600 text-white px-4 py-2 rounded-r-2xl hover:bg-blue-700"
                        >
                            Update
                        </button>
                    </div>
                )}

                <div className="flex justify-between gap-2 mb-8">
  {Array.from({ length: 6 }).map((_, idx) => (
    <input
      key={idx}
      ref={(el) => (inputsRef.current[idx] = el)}
      type="text"
      inputMode="numeric"
      pattern="[0-9]*"
      autoComplete="one-time-code"
      maxLength={1}
      value={otp[idx] || ""}
      onChange={handleOtpChange(idx)}
      onKeyDown={handleKeyDown(idx)}
      onPaste={handlePaste(idx)}
      className="w-12 h-12 rounded-full text-center text-lg font-semibold bg-[#0B214E] text-white outline-none"
    />
  ))}
</div>


                <PrimaryButton onClick={otpValidate} label="Continue" loading={loading} />
                {count === 0 ? (
                    <button onClick={resendOtp} className="text-blue-600 text-sm font-medium mt-4">Resend OTP</button>
                ) : (
                    <div className="text-gray-600 text-sm mt-4">Did you receive OTP? Resend OTP in {count} seconds</div>
                )}
            </div>
            </div>
        </div>
    );
}
